import { config as i18nConfig } from './i18n-config';
import { config as authConfig } from './auth-config';
import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/basic-operation';

const { config: communicationConfig } =
	process.env.REACT_APP_ENV !== 'LOCAL'
		? require('./communication-config.ts')
		: require('./communication-config-local.ts');

const arqConfig: iFacadeConfig = {
	communicationConfig,
	i18nConfig,
	enableAuth: true
};

export { arqConfig };
